export const isPitcher = (position: string) : boolean => {
  return position === "투수"
}
